import { render, staticRenderFns } from "./BestSell.component.vue?vue&type=template&id=7a3b4dd5&scoped=true"
import script from "./BestSell.component.vue?vue&type=script&lang=js"
export * from "./BestSell.component.vue?vue&type=script&lang=js"
import style0 from "./BestSell.component.vue?vue&type=style&index=0&id=7a3b4dd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3b4dd5",
  null
  
)

export default component.exports